import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { Colors } from '../themes';

const SortIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <g id="arrows_up_down-01_svg__Group_224" data-name="Group 224">
      <path
        id="arrows_up_down-01_svg__Line_56"
        data-name="Line 56"
        className="arrows_up_down-01_svg__cls-1"
        d="M21 23V7"
        style={{ stroke: Colors.orange, fill: 'none', strokeWidth: 2 }}
      />
      <path
        id="arrows_up_down-01_svg__Path_141"
        data-name="Path 141"
        className="arrows_up_down-01_svg__cls-1"
        d="M25 11l-4-4-4 4"
        style={{ stroke: Colors.orange, fill: 'none', strokeWidth: 2 }}
      />
    </g>
    <g id="arrows_up_down-01_svg__Group_225" data-name="Group 225">
      <path
        id="arrows_up_down-01_svg__Line_57"
        data-name="Line 57"
        className="arrows_up_down-01_svg__cls-1"
        d="M11 9v16"
        style={{ stroke: Colors.lightGrey, fill: 'none', strokeWidth: 2 }}
      />
      <path
        id="arrows_up_down-01_svg__Path_142"
        data-name="Path 142"
        className="arrows_up_down-01_svg__cls-1"
        d="M15 21l-4 4-4-4"
        style={{ stroke: Colors.lightGrey, fill: 'none', strokeWidth: 2 }}
      />
    </g>
  </SvgIcon>
);

export default SortIcon;
